
















import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { SEARCH_GETTERS_KEYS } from '../../store/search/search.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      hasResults: SEARCH_GETTERS_KEYS.hasResults
    }),
    ...mapState(SUBMODULES_PATHS.search, {
      selectedSort: 'sort'
    }),
    ...mapState(SUBMODULES_PATHS.core, ['openSortList'])
  }
})
export default class Sort extends Vue {}
